var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrSelfService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.1884C20.7 23.1884 18 22.1063 15.9 19.942C13.8 17.7778 12.75 14.9952 12.75 11.5942C12.75 8.19324 13.8 5.41063 15.9 3.24638C18 1.08213 20.7 0 24 0C27.3 0 30 1.08213 32.1 3.24638C34.2 5.41063 35.25 8.19324 35.25 11.5942C35.25 14.9952 34.2 17.7778 32.1 19.942C30 22.1063 27.3 23.1884 24 23.1884ZM0 48V40.7343C0 38.7762 0.475 37.1014 1.425 35.7101C2.375 34.3188 3.6 33.2625 5.1 32.5411C8.45 30.9952 11.6625 29.8357 14.7375 29.0628C17.8125 28.2899 20.9 27.9034 24 27.9034C27.1 27.9034 30.175 28.3027 33.225 29.1015C36.275 29.9002 39.475 31.0467 42.825 32.5411C44.375 33.2625 45.625 34.3188 46.575 35.7101C47.525 37.1014 48 38.7762 48 40.7343V48H0Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrSelfService);
export default __webpack_public_path__ + "static/media/hrSelfService.c723f563bed54f9ecb0e4ff910c9bb35.svg";
export { ForwardRef as ReactComponent };